import React from 'react';

const TabNavigation = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'branding', label: 'Branding' },
    { id: 'hero', label: 'Hero' },
    { id: 'statistics', label: 'Statistics' },
    { id: 'accreditations', label: 'Accreditations' },
    { id: 'infrastructure', label: 'Infrastructure' },
    { id: 'testimonials', label: 'Testimonials' },
    { id: 'collaborations', label: 'Collaborations' },
    { id: 'awards', label: 'Awards' },
    { id: 'leadership', label: 'Leadership' },
    { id: 'recruiters', label: 'Recruiters' },
    { id: 'events', label: 'Events' },
    { id: 'news', label: 'News' },
    { id: 'faq', label: 'FAQ' },
    { id: 'gallery', label: 'Gallery' },
    { id: 'faculty', label: 'Faculty' },
    { id: 'courses', label: 'Programs' },
    { id: 'footer', label: 'Footer' },
    { id: 'seo', label: 'SEO' },
    { id: 'content', label: 'Announcements' }
  ];

  return (
    <div className="w-full bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
      {/* Scrollable Container - hides scrollbar for a clean look */}
      <div className="max-w-7xl mx-auto px-4 overflow-x-auto no-scrollbar scroll-smooth">
        <nav className="flex space-x-2 min-w-max py-2" aria-label="Tabs">
          {tabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  px-4 
                  py-2.5 
                  text-sm 
                  font-medium 
                  rounded-lg 
                  whitespace-nowrap 
                  transition-all 
                  duration-200 
                  focus:outline-none 
                  focus:ring-2 
                  focus:ring-blue-500 
                  focus:ring-offset-2
                  ${
                    isActive
                      ? 'bg-blue-50 text-blue-600 font-semibold shadow-sm border-b-2 border-blue-600'
                      : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                  }
                `}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default TabNavigation;